/**
 * StreamingText Component
 * Displays the in-progress response with a blinking cursor
 */

import { memo, useState, useEffect } from 'react';
import { Box, Text } from 'ink';
import { INK_COLORS, SYMBOLS, COLORS } from '../theme/ink-theme.js';
import { MarkdownText } from './MarkdownText.js';

interface StreamingTextProps {
    text: string;
    isComplete?: boolean;
    rawMode?: boolean;
    showCharCount?: boolean;
}

export const StreamingText = memo<StreamingTextProps>(({
    text,
    isComplete = false,
    rawMode = false,
}) => {
    const [cursorVisible, setCursorVisible] = useState(true);

    useEffect(() => {
        if (isComplete) return;
        const interval = setInterval(() => {
            setCursorVisible(prev => !prev);
        }, 530);
        return () => clearInterval(interval);
    }, [isComplete]);

    return (
        <Box flexDirection="column">
            {/* Response header */}
            <Box marginBottom={0}>
                <Text color={INK_COLORS.secondary} bold>{SYMBOLS.arch} Pæan</Text>
            </Box>

            {/* Content */}
            <Box paddingLeft={2} flexDirection="column">
                {rawMode ? (
                    <Text wrap="wrap">{text}</Text>
                ) : (
                    <MarkdownText>{text}</MarkdownText>
                )}
                {!isComplete && (
                    <Text color={COLORS.primary}>
                        {cursorVisible ? '▌' : ' '}
                    </Text>
                )}
            </Box>
        </Box>
    );
});

StreamingText.displayName = 'StreamingText';
